export class BussinessDocumentsTypeModel {
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsClassId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  description: string = '';
  isRental: boolean = true;
  bussinessDocumentsDianTypeId: number = 0;
  cxcInvoiceConcept: string | null = null;
  cxcCreditNoteConcept: string | null = null;
  cxcDebitNoteConcept: string | null = null;
  active: boolean = true;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
